import * as React from 'react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { inject, observer } from 'mobx-react'
import { IQuestionnaire } from '../../../Model/Questionnaire'
import { ListGroup, ListGroupItem } from 'react-bootstrap'
import DateTimeHelper from '../../../Helpers/DateTimeHelper'

export interface IQuestionnaireDateInfoViewProps {
    className?: string
    questionnaire: IQuestionnaire,
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
@observer
export default class QuestionnaireDateInfoView extends React.Component<IQuestionnaireDateInfoViewProps> {
    render() {
        const { localizationStore, questionnaire, className } = this.props

        if (!questionnaire || !questionnaire.credit || !questionnaire.credit.creditNumber) {
            return ('')
        }

        return (
            <div className={className}>
                <ListGroup>
                    <ListGroupItem className="border-radius-0">
                        <span className="orderDate">
                            {localizationStore!.t!('createDate')}&nbsp;:&nbsp;
                                {DateTimeHelper.formatDateTimeForList(questionnaire.createDate)}
                            {/* {date ? date : localizationStore!.t!('no date')} */}
                        </span>
                    </ListGroupItem>
                    <ListGroupItem className="border-radius-0">
                        <span className="orderDate">
                            {localizationStore!.t!('updateDate')}&nbsp;:&nbsp;
                                {DateTimeHelper.formatDateTimeForList(questionnaire.updateDate)}
                            {/* {date ? date : localizationStore!.t!('no date')} */}
                        </span>
                    </ListGroupItem>
                </ListGroup>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireDateInfoView.tsx